import { render, staticRenderFns } from "./CompanyIntroduction.vue?vue&type=template&id=aa28ba10&scoped=true"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroduction.vue?vue&type=style&index=0&id=aa28ba10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa28ba10",
  null
  
)

export default component.exports